/**
 * LaunchDarkly feature flag keys used in this application.
 * Keys must match exactly the flag keys in the LaunchDarkly dashboard (kebab-case).
 * Add new flag keys here as they are created in the LD dashboard.
 */

export const LAUNCH_DARKLY_FLAGS = {
  'disable-vehicle-for-ny': 'disable-vehicle-for-ny',
  'vehicle-vin-required-enabled': 'vehicle-vin-required-enabled',
  'fullstory-enabled': 'fullstory-enabled',
  'cc-to-ec-page-redirects': 'cc-to-ec-page-redirects',
} as const;

export type LaunchDarklyFlagKey = (typeof LAUNCH_DARKLY_FLAGS)[keyof typeof LAUNCH_DARKLY_FLAGS];
